<template>
    <div class="email-onboarding__check-email flex-column ai-center">
        <div class="email-onboarding__check-email--content flex-column ai-center">
            <div class="typographies-paragraph-medium-regular">
                {{
                    $l10n.__(
                        'Pour poursuivre la configuration, vous devez vérifier votre adresse email en cliquant sur le lien de vérification que vous allez recevoir sur celle-ci.',
                    )
                }}
            </div>
            <div class="flex-row email-onboarding__check-email--content-input-container">
                <CompassFormItem :error="errorMsg">
                    <CompassInput
                        v-model="email"
                        :error="isInputInError"
                        :placeholder="$t.__('common.labels.email')"
                        @input="onInputEmail"
                    />
                </CompassFormItem>
                <CompassButton
                    :disabled="emailIsVerified || isInputInError"
                    :label="$t.__('common.actions.verify')"
                    :loading="isEmailSubmitLoading"
                    @click="onClickSubmitEmail"
                />
            </div>
            <div class="typographies-paragraph-small-regular email-onboarding__check-email--content-input-caption">
                {{ $l10n.__('Si vous souhaitez changer cette adresse email par la suite,')
                }}<br />{{ $l10n.__(' vous devrez procéder à une nouvelle vérification.') }}
            </div>
        </div>
        <CompassAlert
            v-if="emailIsVerified"
            class="email-onboarding__check-email--alert"
            type="success"
            :description="$t.__('email.EmailOnboardingCheckEmail.allready_verified_email')"
            :action="{
                label: $l10n.__('Continuer'),
                callback: () => $emit('onClickContinue'),
            }"
            :showClose="false"
        />
    </div>
</template>

<script>
import onboardingEmail from 'api/onboarding/email/onboardingEmail.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateUser, mapActions: mapActionsUser } = createNamespacedHelpers('user');
const { mapState: mapStateCorp } = createNamespacedHelpers('corp');
export default {
    props: {
        sentFromCorp: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            email: '',
            customErrorMsg: null,
            isEmailSubmitLoading: false,
        };
    },
    computed: {
        ...mapStateUser({
            senderEmail: 'senderEmail',
            emailIsVerified: 'emailIsVerified',
            pendingEmail: 'pendingEmail',
            emailUser: 'email',
        }),
        ...mapStateCorp({
            emailCorp: 'email',
        }),
        errorMsg() {
            if (this.email?.toLowerCase().length === 0) {
                return this.$l10n.__('Ce champ est requis');
            } else if (this.customErrorMsg) {
                return this.$l10n.__(this.customErrorMsg);
            }
            return '';
        },
        isInputInError() {
            return this.errorMsg?.length !== 0;
        },
    },
    created() {
        if (this.emailIsVerified) {
            this.email = this.senderEmail;
        } else {
            this.email = this.sentFromCorp ? this.emailCorp : this.emailUser;
        }
    },
    methods: {
        ...mapActionsUser(['updateSenderEmail', 'updatePendingEmail', 'updateEmailIsVerified']),
        onInputEmail() {
            this.customErrorMsg = null;
            this.updateEmailIsVerified(false);
        },
        onClickSubmitEmail() {
            this.isEmailSubmitLoading = true;
            onboardingEmail
                .validateEmail(this.email)
                .then(({ verified }) => {
                    this.updateEmailIsVerified(verified);
                    this.$emit('onEmailSubmitted', this.email);
                })
                .catch(({ code }) => {
                    if (code === 400) {
                        this.customErrorMsg = 'Saisissez un email valide';
                    }
                })
                .finally(() => (this.isEmailSubmitLoading = false));
        },
    },
};
</script>

<style lang="scss">
.email-onboarding__check-email {
    gap: 24px;

    .email-onboarding__check-email--content {
        gap: 16px;
        text-align: center;
        width: 480px;
        &-input-caption {
            color: var(--colors-common-text-standard-caption);
        }
        .email-onboarding__check-email--content-input-container {
            align-items: baseline;
            gap: 8px;

            .compass-form-item {
                width: 320px;

                .compass-form-item__label {
                    display: none;
                }
            }
        }
    }
}
</style>
